import * as React from 'react';
import { MenuButton } from './MenuButton';
import { LoginButton } from './LoginButton';
import { SiteMenu } from './SiteMenu';
import { IEServicesSiteHeaderProps, IEServicesSiteHeaderState } from './EServicesSiteHeader.types';
import { SearchButton } from 'sos-common/js/components/SiteHeader/SearchButton';
import { VelocityComponent } from 'velocity-react';
import { Search } from 'sos-common/js/components/Search/Search';

const menuId = 'mobile-menu-container';
const searchPanelId = 'search-panel';

/**
 * Renders the entire site header. Includes login button, my page button, mobile menu and site functions.
 */
export class EServicesSiteHeader extends React.Component<IEServicesSiteHeaderProps, IEServicesSiteHeaderState> {
  private _searchPanelRef: HTMLElement;
  private _searchPanelHeight: string;

  constructor(props: IEServicesSiteHeaderProps) {
    super(props);
    this.setMenuOpenState = this.setMenuOpenState.bind(this);
    this.state = {
      menuIsOpen: false,
      searchIsOpen: false,
      searchIsReadyToFocus: false,
      showMyCases: false,
    };
    this._searchPanelHeight = '8.1rem';
  }

  static defaultProps = {
    showSearch: false,
  };

  componentDidMount() {
    document.addEventListener('iu_show', this.showMyCases);
  }

  componentWillUnmount() {
    document.removeEventListener('iu_show', this.showMyCases);
  }

  showMyCases = () => {
    this.setState({
      showMyCases: true,
    });
  };

  searchPanelAnimationBegin = (): void => {
    if (this.state.searchIsOpen) {
      this._searchPanelRef.style.display = 'block';
      this.setState({
        searchIsReadyToFocus: true,
      });
    }
  };

  searchPanelAnimationComplete = (): void => {
    if (this.state.searchIsOpen) {
      this._searchPanelRef.style.display = 'block';
    } else {
      this._searchPanelRef.style.display = 'none';
    }
    this.setState({
      searchIsReadyToFocus: false,
    });
  };

  setMenuOpenState = () => {
    if (!this.state.menuIsOpen) {
      document.getElementsByTagName('body')[0].classList.add('lock-scrolling', 'mobile-menu-open');
    } else {
      document.getElementsByTagName('body')[0].classList.remove('lock-scrolling', 'mobile-menu-open');
    }
    this.setState((prevState) => ({
      menuIsOpen: !prevState.menuIsOpen,
    }));
  };

  buttonClickAction = () => {
    location.href = this.props.loginbuttonUrl;
  };

  buttonMyPageClickAction = () => {
    location.href = this.props.MyPagebuttonUrl;
  };

  buttonMyCasesClickAction = () => {
    location.href = this.props.myCasesButtonUrl ?? '';
  };

  setSearchOpenState = () => {
    this.setState((prevState) => ({
      searchIsOpen: !prevState.searchIsOpen,
    }));
  };

  render(): JSX.Element {
    return (
      <header
        className={`siteheader ${this.state.menuIsOpen ? 'siteheader__fixed' : ''}`}
        aria-label="Sidhuvud (för små enheter)">
        <div className="siteheader__top rtl">
          <MenuButton
            menuStateCallback={this.setMenuOpenState}
            menuText={this.props.menuText}
            menuIsOpen={this.state.menuIsOpen}
            menuId={menuId}
            ariaLabel={this.state.menuIsOpen ? 'Stäng' : 'Öppna'}
          />
          <a href="/" className="siteheader__bigtext siteheader__home ">
            {this.props.eServiceName}
          </a>
          <div className="siteheader__noshrink">
            {this.props.showSearch && (
              <SearchButton
                searchStateCallback={this.setSearchOpenState}
                searchText={this.props.searchText}
                searchIsOpen={this.state.searchIsOpen}
                searchPanelId={searchPanelId}
              />
            )}
            {this.props.showMyPageButton && (
              <LoginButton buttonText={this.props.MyPageButtonText} loginClickCallback={this.buttonMyPageClickAction} />
            )}

            {(this.props.showMyCasesButton || this.state.showMyCases) && (
              <LoginButton
                buttonText={this.props.myCasesButtonText}
                loginClickCallback={this.buttonMyCasesClickAction}
              />
            )}

            <LoginButton
              iconType={this.props.showMyPageButton ? 'fontawesome/arrow-right-from-bracket-solid' : null}
              buttonText={this.props.loginButtonText}
              loginClickCallback={this.buttonClickAction}
            />
          </div>
        </div>
        {this.props.showSearch && (
          <VelocityComponent
            runOnMount={false}
            duration={250}
            animation={
              this.state.searchIsOpen
                ? // Open
                  { height: this._searchPanelHeight }
                : // Close
                  { height: 0 }
            }
            begin={this.searchPanelAnimationBegin}
            complete={this.searchPanelAnimationComplete}>
            <div
              id={searchPanelId}
              aria-hidden={!this.state.searchIsOpen}
              ref={(el) => (this._searchPanelRef = el)}
              className={'siteheader__searchpanel'}>
              <Search
                findUrl={this.props.findUrl}
                placeholder={this.props.searchPlaceHolderText || this.props.searchText}
                focus={this.state.searchIsReadyToFocus}
                searchPage={this.props.searchPage}
                searchId="search_mobile-siteheader"
              />
            </div>
          </VelocityComponent>
        )}

        <SiteMenu
          language={this.props.language}
          menuId={menuId}
          menuIsOpen={this.state.menuIsOpen}
          currentPageId={this.props.currentPageId}
          isStartPage={this.props.isStartPage}
          siteMapUrl={''}
          minorityLanguages={[]}
          translatedItems={[]}
          translatedStartPageItems={[]}
          treeNodes={this.props.treeNodes}
          startPageid={this.props.startPageid}
          isCampaignPage={this.props.isCampaignPage}
        />
      </header>
    );
  }
}
